import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, Sparkles, ArrowRight, Globe, SendIcon, UserIcon, PhoneIcon, DollarSignIcon, CheckCircleIcon } from 'lucide-react';
const content = {
  en: {
    eyebrow: 'Premium Domain For Sale',
    copy: 'Unlock the potential of your online presence with this premium domain, perfectly suited for your brand. This is your chance to stand out and drive traffic effortlessly.',
    ctaInline: 'Contact us',
    copyEnd: 'to make this domain yours today.',
    cta: 'Make an Offer',
    footer: 'All rights reserved.',
    formTitle: 'Interested? Tell us about your offer.',
    namePlaceholder: 'Your Full Name',
    phonePlaceholder: 'Phone Number',
    offerPlaceholder: 'Your Offer (USD)',
    submit: 'Submit Offer',
    success: 'Thank you! Your offer has been sent.',
    required: 'Please fill in all fields.'
  },
  es: {
    eyebrow: 'Dominio Premium En Venta',
    copy: 'Desbloquea el potencial de tu presencia en línea con este dominio premium, perfecto para tu marca. Esta es tu oportunidad de destacar y generar tráfico sin esfuerzo.',
    ctaInline: 'Contáctanos',
    copyEnd: 'para hacer tuyo este dominio hoy.',
    cta: 'Hacer una Oferta',
    footer: 'Todos los derechos reservados.',
    formTitle: '¿Interesado? Cuéntanos sobre tu oferta.',
    namePlaceholder: 'Tu Nombre Completo',
    phonePlaceholder: 'Número de Teléfono',
    offerPlaceholder: 'Tu Oferta (USD)',
    submit: 'Enviar Oferta',
    success: '¡Gracias! Tu oferta ha sido enviada.',
    required: 'Por favor completa todos los campos.'
  }
};
export function DomainLanding() {
  const [lang, setLang] = useState<'en' | 'es'>('en');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    offer: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const t = content[lang];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!formData.name.trim() || !formData.phone.trim() || !formData.offer.trim()) {
      setError(t.required);
      return;
    }
    const subject = encodeURIComponent('Domain Offer for totembeachrestobar.com');
    const body = encodeURIComponent(`Name: ${formData.name}\nPhone: ${formData.phone}\nOffer: $${formData.offer}\n\nThis inquiry is regarding the domain totembeachrestobar.com`);
    window.location.href = `mailto:j1981rodriguez@yahoo.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };
  const scrollToForm = () => {
    setShowForm(true);
    setTimeout(() => {
      document.getElementById('contact-form')?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 100);
  };
  return <div className="min-h-screen flex flex-col relative overflow-hidden bg-neutral-950 selection:bg-amber-500/30" data-id="element-1">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-900/10 via-neutral-950 to-neutral-950 pointer-events-none" data-id="element-2" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-3" />

      {/* Flashing FOR SALE Sign - hops corner to corner */}
      <motion.div animate={{
      top: ['5%', '5%', '80%', '80%', '5%'],
      left: ['5%', '85%', '85%', '5%', '5%'],
      rotate: [0, 5, -5, 3, 0],
      scale: [1, 1.05, 0.95, 1.05, 1],
      opacity: [1, 0.4, 1, 0.4, 1]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="fixed z-30 px-5 py-2 bg-red-600 border-2 border-red-400 rounded-md shadow-[0_0_25px_rgba(239,68,68,0.5)] cursor-pointer" style={{
      position: 'fixed'
    }} data-id="element-4">
        <motion.span animate={{
        x: [0, 6, -6, 4, 0]
      }} transition={{
        duration: 0.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="block text-white font-bold text-sm md:text-base tracking-[0.25em] uppercase whitespace-nowrap" data-id="element-5">
          {lang === 'en' ? '🔴 For Sale 🔴' : '🔴 En Venta 🔴'}
        </motion.span>
      </motion.div>

      {/* Language Toggle */}
      <div className="absolute top-6 right-6 z-20" data-id="element-6">
        <button onClick={() => setLang(lang === 'en' ? 'es' : 'en')} className="group flex items-center gap-2 px-3 py-2 rounded-full bg-neutral-900/80 border border-neutral-800 text-neutral-400 hover:text-amber-400 hover:border-amber-500/30 transition-all backdrop-blur-sm text-sm font-medium" aria-label={lang === 'en' ? 'Cambiar a español' : 'Switch to English'} data-id="element-7">
          <Globe className="w-4 h-4" data-id="element-8" />
          <span className="tracking-wider" data-id="element-9">
            {lang === 'en' ? 'Español' : 'English'}
          </span>
        </button>
      </div>

      {/* Main Content */}
      <main className="flex-grow flex flex-col items-center justify-center px-6 relative z-10 py-24" data-id="element-10">
        <div className="max-w-3xl mx-auto text-center" data-id="element-11">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="flex flex-col items-center" data-id="element-12">
            {/* Eyebrow */}
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-sm font-medium tracking-wide mb-8" data-id="element-13">
              <Sparkles className="w-4 h-4" data-id="element-14" />
              <AnimatePresence mode="wait" data-id="element-15">
                <motion.span key={lang + '-eyebrow'} initial={{
                opacity: 0,
                y: 4
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -4
              }} transition={{
                duration: 0.2
              }} data-id="element-16">
                  {t.eyebrow}
                </motion.span>
              </AnimatePresence>
            </div>

            {/* Domain Name */}
            <motion.h1 initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2,
            ease: 'easeOut'
          }} className="font-playfair text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-8 text-transparent bg-clip-text bg-gradient-to-b from-white via-neutral-200 to-neutral-500" data-id="element-17">
              totembeachrestobar<span className="text-amber-500" data-id="element-18">.com</span>
            </motion.h1>

            {/* Copy */}
            <AnimatePresence mode="wait" data-id="element-19">
              <motion.p key={lang + '-copy'} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="text-lg md:text-xl text-neutral-400 leading-relaxed max-w-2xl mx-auto mb-12" data-id="element-20">
                {t.copy}{' '}
                <button onClick={scrollToForm} className="text-amber-400 hover:text-amber-300 underline underline-offset-4 decoration-amber-400/30 hover:decoration-amber-400 transition-all cursor-pointer" data-id="element-21">
                  {t.ctaInline}
                </button>{' '}
                {t.copyEnd}
              </motion.p>
            </AnimatePresence>

            {/* CTA Button */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.6,
            ease: 'easeOut'
          }} data-id="element-22">
              <button onClick={scrollToForm} className="group relative inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-neutral-950 rounded-full font-semibold text-lg overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_40px_-10px_rgba(245,158,11,0.5)] focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 focus:ring-offset-neutral-950" data-id="element-23">
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-24" />
                <Mail className="w-5 h-5 relative z-10" data-id="element-25" />
                <AnimatePresence mode="wait" data-id="element-26">
                  <motion.span key={lang + '-cta'} initial={{
                  opacity: 0
                }} animate={{
                  opacity: 1
                }} exit={{
                  opacity: 0
                }} transition={{
                  duration: 0.2
                }} className="relative z-10" data-id="element-27">
                    {t.cta}
                  </motion.span>
                </AnimatePresence>
                <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-28" />
              </button>
            </motion.div>
          </motion.div>
        </div>

        {/* Contact Form Section */}
        <AnimatePresence data-id="element-29">
          {showForm && <motion.div id="contact-form" initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 40
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="w-full max-w-lg mx-auto mt-20" data-id="element-30">
              <div className="bg-neutral-900/70 border border-neutral-800 rounded-2xl p-8 backdrop-blur-md" data-id="element-31">
                <h2 className="text-2xl font-bold text-white mb-2 text-center font-playfair" data-id="element-32">
                  {t.formTitle}
                </h2>
                <div className="w-12 h-1 bg-amber-500 rounded-full mx-auto mb-8" data-id="element-33" />

                {submitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="flex flex-col items-center gap-4 py-8" data-id="element-34">
                    <CheckCircleIcon className="w-12 h-12 text-green-500" data-id="element-35" />
                    <p className="text-green-400 text-lg font-medium text-center" data-id="element-36">
                      {t.success}
                    </p>
                  </motion.div> : <form onSubmit={handleSubmit} className="flex flex-col gap-5" data-id="element-37">
                    {/* Name */}
                    <div className="relative" data-id="element-38">
                      <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-39" />
                      <input type="text" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} placeholder={t.namePlaceholder} className="w-full pl-12 pr-4 py-3.5 bg-neutral-800/60 border border-neutral-700 rounded-xl text-white placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500/50 transition-all" data-id="element-40" />
                    </div>

                    {/* Phone */}
                    <div className="relative" data-id="element-41">
                      <PhoneIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-42" />
                      <input type="tel" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} placeholder={t.phonePlaceholder} className="w-full pl-12 pr-4 py-3.5 bg-neutral-800/60 border border-neutral-700 rounded-xl text-white placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500/50 transition-all" data-id="element-43" />
                    </div>

                    {/* Offer */}
                    <div className="relative" data-id="element-44">
                      <DollarSignIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-45" />
                      <input type="text" value={formData.offer} onChange={e => setFormData({
                  ...formData,
                  offer: e.target.value
                })} placeholder={t.offerPlaceholder} className="w-full pl-12 pr-4 py-3.5 bg-neutral-800/60 border border-neutral-700 rounded-xl text-white placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500/50 transition-all" data-id="element-46" />
                    </div>

                    {/* Error */}
                    {error && <motion.p initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} className="text-red-400 text-sm text-center" data-id="element-47">
                        {error}
                      </motion.p>}

                    {/* Submit */}
                    <button type="submit" className="group relative flex items-center justify-center gap-3 w-full py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-neutral-950 rounded-xl font-semibold text-lg overflow-hidden transition-all hover:scale-[1.02] hover:shadow-[0_0_30px_-10px_rgba(245,158,11,0.4)] focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 focus:ring-offset-neutral-950" data-id="element-48">
                      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-49" />
                      <SendIcon className="w-5 h-5 relative z-10" data-id="element-50" />
                      <span className="relative z-10" data-id="element-51">{t.submit}</span>
                    </button>
                  </form>}
              </div>
            </motion.div>}
        </AnimatePresence>
      </main>

      {/* Footer */}
      <motion.footer initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 1
    }} className="py-8 text-center text-neutral-600 text-sm relative z-10" data-id="element-52">
        <p data-id="element-53">
          &copy; {new Date().getFullYear()} totembeachrestobar.com. {t.footer}
        </p>
      </motion.footer>
    </div>;
}